import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_273: DocMigration = {
  maxSchemaVersion: "0.0.273",
  description: "Move Gable End Framing Settings to roofSideOverrides",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofFramingSettings = {} } = roof;
      let { roofSideOverrides = {} } = roof;
      const { startFramingType, endFramingType } = roofFramingSettings;
      if (startFramingType !== undefined) {
        roofSideOverrides = {
          ...roofSideOverrides,
          START: {
            ...roofSideOverrides.START,
            framingType: startFramingType,
          },
        };
      }
      if (endFramingType !== undefined) {
        roofSideOverrides = {
          ...roofSideOverrides,
          END: {
            ...roofSideOverrides.END,
            framingType: endFramingType,
          },
        };
      }

      delete roof.roofFramingSettings;

      roofs[id] = {
        ...roof,
        roofSideOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_273;
